import { getFormatData } from '../../api/formatDataUser'

const state = {
  formatData: {},
}

const getters = {
  getFormates: state => state.formatData
}

const mutations = {
  SET_FORMAT_DATA: (state, pl)=>{
    let newFormatData = {}
    for(let itm of pl){
      newFormatData = Object.assign(newFormatData, itm)
    }
    state.formatData = newFormatData
  }
}

const actions = {
  getFormatData:  async ({commit}) => {
     await getFormatData().then(r =>{
       commit('SET_FORMAT_DATA', r)
    }).catch(err => console.dir(err))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
